module.exports = __webpack_public_path__ + "img/IconProjectTypeSocialImpactWhite.1aa1b3e8.png";